export const modalText = (text?: string) => ({
  deleteConfirmBodyDefault: `Are you sure you want to delete the item?`,
  deleteConfirmBody: `Are you sure you want to ${text?.toLowerCase()}?`,
});
